import React, { Fragment, useState } from 'react'
import { Form } from 'react-bootstrap'
import { createDependency, deleteDependency, updateDependency } from '../../api_methods'

// Riga che gestisce le regole dipendenti (un selettore per ogni colonna corrispondente ad un'altra dimensione del report/gruppo)
export default function DimensionRuleDependency({
  rule,
  disabled, // Può essere disabilitato, quando la regola è al momento non valida (quindi se lasciassi modificabile il selettore il backend mi farebbe ciao ciao con la manina)
  options, // le opzioni sono i valori delle regole manual delle altre dimensioni
  valueList, // la lista di valori è una lista di valori delle regole dipendenti di QUESTA dimensione, che recupero da backend e devo mostrare a frontend
  ratio,
}) {
  const [selected, setSelected] = useState(
    valueList.length > 0 ? valueList[0].tag_it : ''
  )

  // Do feedback all'utente colorando di rosso o verde il selettore
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  // Porto le modifiche a backend, ad ogni onChange, selezionando un gruppo o un report (uno dei due sarà vuoto, controllo a backend quale)
  const handleSelection = async (e) => {
    e.preventDefault();
    setError(false);
    setSuccess(false);

    const newValue = e.target.value;
    const oldValue = selected; // The current state before the change

    // Do nothing if the value hasn't changed
    if (newValue === oldValue) {
        return;
    }

    const isDeleting = newValue === '' && oldValue !== '';
    const isCreating = newValue !== '' && oldValue === '';
    const isUpdating = newValue !== '' && oldValue !== '';

    try {
        if (isDeleting) {
            // Guard against empty valueList
            if (!valueList || valueList.length === 0) {
                console.error("Attempted to delete a dependency that doesn't exist.");
                setError(true);
                return;
            }
            await deleteDependency(valueList[0].id);
        }

        if (isCreating || isUpdating) {
            // Find the corresponding 'to_rule' from the options
            const toRule = options.find((o) => o.tag_it === newValue);

            // Guard against not finding the rule in the options
            if (!toRule) {
                console.error(`Could not find a rule with tag_it: ${newValue}`);
                setError(true);
                return;
            }

            if (isCreating) {
                const payload = { from_rule_id: rule.id, to_rule_id: toRule.id };
                await createDependency(payload);
            }

            if (isUpdating) {
                // Guard against empty valueList
                if (!valueList || valueList.length === 0) {
                     console.error("Attempted to update a dependency that doesn't exist.");
                     setError(true);
                     return;
                }
                const payload = { to_rule_id: toRule.id };
                await updateDependency(valueList[0].id, payload);
            }
        }

        // If we reached here without errors, the operation was successful
        setSelected(newValue);
        setSuccess(true);

    } catch (err) {
        console.error("Failed to update dependency:", err);
        setError(true);
    }
};

  return (
    <Fragment>
      <div style={{ width: ratio.dependency }}>
        <fieldset className="w-seo-control-field">
          <Form.Control
            className="w-form-control"
            as="select"
            value={selected}
            isValid={success}
            isInvalid={error}
            onChange={handleSelection}
            disabled={disabled}
          >
            <option value={''}>{}</option>
            {options &&
              options.map((o, index) => (
                <option key={index} value={o.tag_it}>
                  {o.tag_it}
                </option>
              ))}
          </Form.Control>
        </fieldset>
      </div>
    </Fragment>
  )
}
